module.exports = __webpack_public_path__ + "img/inviteapple.7d5337b8.png";